export const LAST_VISITED_PATH_STORAGE_KEY = 'lastVisitedPath';
export const TRACKED_PATH_PREFIXES = ['/dashboards', '/alerts', '/assets', '/home'];
